import { render, staticRenderFns } from "./App.vue?vue&type=template&id=20d2984b"
import script from "./assets/icon/iconfont.js?vue&type=script&lang=js&external"
export * from "./assets/icon/iconfont.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=20d2984b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports